import React from 'react';
import styled from 'styled-components';

interface StyleProps {
  size: number;
  color: string;
}

interface Props {
  color?: string;
  size?: number;
  title: string;
}

const H5 = ({ color = '#000', size = 14, title }: Props) => {
  return (
    <H5Style color={color} size={size}>
      {title}
    </H5Style>
  );
};

export default H5;

/* styles */
const H5Style = styled.h5<StyleProps>`
  font-size: ${({ size }) => `${size}px`};
  color: ${({ color }) => color};
`;
